const redirectToDeeplink = (deeplink) => {
  document.location = deeplink;
};

export default redirectToDeeplink;
